import ParameterErrors from '../errors/ParameterErrors';
import GenericWindow from '../window/GenericWindow';
import Dialog from '../components/Dialog';
import WindowType from '../enums/WindowType';
import getViewportDimensions from '../ui_core/getViewportDimensions';
import PlotDetailedInformationsManager from './PlotDetailedInformationsManager';
import PlotComparisonScrollManager from './PlotComparisonScrollManager';
import GoogleAnalytics from '../google/GoogleAnalytics';
import './PlotComparisonManager.css';
const {throwNotProvided}=ParameterErrors;
const eventNamesToDetectWhenToExitComparison = [GenericWindow.EventNames.DRAG_STARTED, 
GenericWindow.EventNames.MAXIMIZED, GenericWindow.EventNames.UNMAXIMIZED, GenericWindow.EventNames.MINIMIZED, 
	GenericWindow.EventNames.CLOSED, GenericWindow.EventNames.WINDOW_DESTROYED, GenericWindow.EventNames.RESIZE_STARTED];
export default class PlotComparisonManager {
	static get instance(){
		if(!PlotComparisonManager._instance){
			throw new Error('Not initialized');
		}
		return PlotComparisonManager._instance;
	}
	static initialize({plotDetailedInformationsManager, sitePlanElement}){
		PlotComparisonManager._instance = new PlotComparisonManager({plotDetailedInformationsManager, sitePlanElement});
	}
	constructor({plotDetailedInformationsManager, sitePlanElement}){
		this._plotDetailedInformationsManager=plotDetailedInformationsManager;
		this.compare = this.compare.bind(this);
		this._sitePlanElement = sitePlanElement;
		this._plotComparisonElement = document.createElement('div');
		this._plotComparisonElement.classList.add('plot-comparison');
		this._plotComparisonTextElement = document.createElement('div');
		this._plotComparisonTextElement.classList.add('text');
		this._plotComparisonElement.appendChild(this._plotComparisonTextElement);
		this._plotComparisonTextElement.innerHTML='';
		this._sitePlanElement.appendChild(this._plotComparisonElement);
		this._showTooManyPlotsSelectedToDoComparison = this._showTooManyPlotsSelectedToDoComparison.bind(this);
		this._showAtLeastTwoPlotsMustBeSelectedDialog = this._showAtLeastTwoPlotsMustBeSelectedDialog.bind(this);
		this._setComparingClassOnSitePlan= this._setComparingClassOnSitePlan.bind(this);
		this._getNPlotDetailedInformationWindowsInEachDirection = this._getNPlotDetailedInformationWindowsInEachDirection.bind(this);
		this._getPositionNextWindow = this._getPositionNextWindow.bind(this);
		this._registerEventsToDetermineWhenToExit = this._registerEventsToDetermineWhenToExit.bind(this);
		this._exitComparisonMode = this._exitComparisonMode.bind(this);
	}
	compare(siteJsonUnitPlots){
		if(siteJsonUnitPlots.length<2){
			this._showAtLeastTwoPlotsMustBeSelectedDialog();
			return;
		}
		if(siteJsonUnitPlots.length>9){
			this._showTooManyPlotsSelectedToDoComparison();
			return;
		}
		const plotDetailedInformations = siteJsonUnitPlots.map(siteJsonUnitPlot=>
			this._plotDetailedInformationsManager.show(siteJsonUnitPlot)
		);
		const positionNextWindow = this._getPositionNextWindow(plotDetailedInformations.length);
		plotDetailedInformations.forEach(plotDetailedInformation=>{
			positionNextWindow(plotDetailedInformation);
			plotDetailedInformation.scrollToTop();
			plotDetailedInformation.window.bringToFront();
		});
		this._registerEventsToDetermineWhenToExit(plotDetailedInformations);
		this._setComparingClassOnSitePlan(true);
		this._PlotComparisonScrollManager&&this._PlotComparisonScrollManager.dispose();
		this._PlotComparisonScrollManager = new PlotComparisonScrollManager({plotDetailedInformations});
		GoogleAnalytics.logEvent('comparedPlots', {plotNumbers:plotDetailedInformations.map(plotDetailedInformation=>plotDetailedInformation.number)});
	}
	_registerEventsToDetermineWhenToExit(plotDetailedInformations){
		this._unregisterEventsToDetermineWhenToExit&&this._unregisterEventsToDetermineWhenToExit();
		this._unregisterEventsToDetermineWhenToExit=()=>{
			plotDetailedInformations.forEach(plotDetailedInformation=>{
				eventNamesToDetectWhenToExitComparison.forEach(eventName=>
					plotDetailedInformation.window.removeEventListener(eventName, this._exitComparisonMode)
				);
			});
			window.removeEventListener('resize', this._exitComparisonMode);
		};
		plotDetailedInformations.forEach(plotDetailedInformation=>{
			eventNamesToDetectWhenToExitComparison.forEach(eventName=>
				plotDetailedInformation.window.addEventListener(eventName, this._exitComparisonMode)
			);
		});
		window.addEventListener('resize', this._exitComparisonMode);
	}
	_exitComparisonMode(e){
		this._unregisterEventsToDetermineWhenToExit&&this._unregisterEventsToDetermineWhenToExit();
		this._unregisterEventsToDetermineWhenToExit= null;
		this._setComparingClassOnSitePlan(false);
		this._PlotComparisonScrollManager&&this._PlotComparisonScrollManager.dispose();
		this._plotComparisonScrollManager = null;
	}
	_getPositionNextWindow(nPlotDetailedInformations){
		const nPlotDetailedInformationWindowsInEachDirection = this._getNPlotDetailedInformationWindowsInEachDirection(nPlotDetailedInformations);
		const viewportDimensions = getViewportDimensions();
		const windowDimensionsPx = [
			viewportDimensions[0]/nPlotDetailedInformationWindowsInEachDirection[0],
			viewportDimensions[1]/nPlotDetailedInformationWindowsInEachDirection[1]
		];
		let nX = 0;
		let nY = 0;
		const width = windowDimensionsPx[0];
		const height = windowDimensionsPx[1];
		return (plotDetailedInformation)=>{
		if(nX>=nPlotDetailedInformationWindowsInEachDirection[0]){
				nX=0;
				nY++;
			}
			const left = width*nX;
			const top = height*nY;
			plotDetailedInformation.window.setWindowSizePosition({
				width:width, 
				height:height,
				top:top,
				left:left
			});
			nX++;
		};
	}
	_setComparingClassOnSitePlan(value){
		if(value)
			this._sitePlanElement.classList.add('comparing-plots');
		else
			this._sitePlanElement.classList.remove('comparing-plots');
	}
	_showAtLeastTwoPlotsMustBeSelectedDialog(){
		this._currentDialog = Dialog.create({
			title:'Error', 
			className:'brochure-generation-result-dialog error',
			message:'You must select at least two plots to do comparison!',
			options:[{text:'OK'}]}
		);
	}
	_showTooManyPlotsSelectedToDoComparison(){
		this._currentDialog = Dialog.create({
			title:'Error', 
			className:'brochure-generation-result-dialog error',
			message:'Too many plots are selected to do comparison!',
			options:[{text:'OK'}]}
		);
	}
	_getNPlotDetailedInformationWindowsInEachDirection(nPlotDetailedInformations){
		const aspectRatio = this._sitePlanElement.offsetWidth/this._sitePlanElement.offsetHeight;
		switch(nPlotDetailedInformations){
			case 2:
			case 3:
				if(aspectRatio>1)
					return [nPlotDetailedInformations, 1];
				return [1, nPlotDetailedInformations];
			case 4:
				return [2,2];
			case 5:
			case 6:
				if(aspectRatio>1)
					return [3, 2];
				return [2, 3];
			case 7:
			case 8:
				if(aspectRatio>1)
					return [4, 2];
				return [2, 4];
			default:
				throw new Error('Not implemented');
		}
	}
}